(ns practitest.frontend.user-activity-log.events
  (:require
   [re-frame.core :as re-frame]))

(re-frame/reg-event-db
 ::initialize
 (fn [db [_ config]]
   (update db :user-activity-log merge
           {:entries (get config :user_activity_log [])
            :account-projects (get config :account_projects [])})))

(re-frame/reg-event-db
 ::init-complete
 (fn [db _]
   (assoc-in db [:user-activity-log :init-complete?] true)))
